import React, { Component } from 'react';
// REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// ACTION
import {
  setPreviewTourData,
  cleanPreviewTourData,
} from 'actions/Map/preview-marker-data.action';
import { setPreviewTourPoly } from 'actions/Map/preview-polyline.action';
import {
  tourFullDataId,
  tourFullMapPosition,
} from 'actions/FullTour/full_tour_view.action';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { isMobileOnly } from 'react-device-detect';
import {
  openModalTourDownload,
  TourDownloadBasketData,
  TourDownloadCoord,
} from '../../../actions/TourDownload/tourDownloadGps.action';
// COMPONENT
import TourPreview from './preview';
import BikeClubMainPreview from '../BikerClub/bikeClubMainPreview/bikeClubMainPreview';
import TrackPreview from '../Track/trackPreview/trackPreview';
import PlacePreview from '../Places/PlacePreview/placePreview';
// MOBILE COMPONENT
import MobilePreview from '../../Mobile/TourPreview/mobilePreview';

// SVG,IMAGE
import { BookmarkIcon, BookmarkShapeIcon } from '../MainMenu/svg';
// PROPTYPES
import { DownloadTourGpsProps } from '../../../constants/PropType/propTypesDownloadTourGps';
import { MapDataProps } from '../../../constants/PropType/propTypesMapData';
import { PreviewPolyProps } from '../../../constants/PropType/propTypesPreviewPoly';
import { RouterProps } from '../../../constants/PropType/propTypesRouter';
import { changeTourMode } from '../../../actions/Map/tour.full.data.action';

const ifId = (router) => {
  return router.location.pathname.includes('tour/') &&
    !router.location.pathname.includes('folder')
    ? parseInt(
        router.location.pathname
          .replace(/[^\w\s]/gi, '')
          .replace(' ', '_')
          .split('_')
          .pop()
      )
    : 0;
};

class Previewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //   bookmark: false,
      readMore: true,
      width: window.innerWidth,
      lang: 'en',
    };
  }

  readMoreChange = () => {
    this.setState((state) => ({
      readMore: !state.readMore,
    }));
  };

  UNSAFE_componentWillUpdate() {
    if (this.state.readMore === false) {
      this.setReadMore();
    }
  }

  setReadMore = () => {
    this.setState({
      readMore: true,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.scope !== prevProps.scope) {
      this.props.cleanPreviewTourData();
    }
  }

  // ACTION RESIZE WINDOW
  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  // getClassForPrew = (width) => {

  // }

  handleWindowSizeChange = () => {
    const prew = document.getElementById('clubPreviewContainer');
    if (prew) {
      //   this.setState({ prewWidth: prew.offsetWidth });
      // this.getClassForPrew(prew.offsetWidth);
    }

    if (this.state.width !== window.innerWidth) {
      this.setState({ width: window.innerWidth });
    }
  }; //

  chooseBookmark = (el, id, data) => {
    data.bookmark = !data.bookmark;
    // this.setState({ bookmark: data.bookmark });
  };

  bookmark = (bookmarked) => {
    return bookmarked ? (
      <BookmarkShapeIcon className="bookmark" />
    ) : (
      <BookmarkIcon className="bookmark" />
    );
  };

  action = () => {
    const tourList = this.props.mapData.data;
    const hiperPrev =
      tourList[tourList.findIndex((t) => t.id === this.props.resp.data.id)];
    const mapPosition = {
      lat: hiperPrev.lat,
      lng: hiperPrev.lng,
    };
    this.props.tourFullDataId({ id: this.props.poly.id });
    this.props.tourFullMapPosition(mapPosition);
  };

  urlTitle = (props) => {
    if (props.title) {
      return props.title.replace(/[^\w\s]/gi, '').replace(/ /g, '_');
    }
    return '';
  };

  hasUserPermition = () => {
    return (
      this.props.userAuth &&
      this.props.userAuth.id &&
      this.props.resp.data &&
      (+this.props.userAuth.id === +this.props.resp.data.owner ||
        (this.props.resp.data.owner &&
          +this.props.userAuth.id === +this.props.resp.data.owner.id))
    );
  };

  getPreviewByScope = () => {
    let scope = this.props.resp.data.scope
      ? this.props.resp.data.scope
      : this.props.scope;
    if (scope === 'club_naf') {
      scope = 'club';
    }
    switch (scope) {
      case 'club':
      case 'bikerbed':
        return (
          <BikeClubMainPreview
            previewJson={this.props.resp.data}
            router={this.props.router}
            fetching={this.props.resp.fetching}
            fetched={this.props.resp.fetched}
            closePreviewer={this.props.closePreviewer}
            urlTitle={this.urlTitle(this.props.resp.data)}
            scope={this.props.scope}
            fromList={this.props.fromList}
          />
        );
      case 'track':
        return (
          <TrackPreview
            previewJson={this.props.resp.data}
            fetching={this.props.resp.fetching}
            fetched={this.props.resp.fetched}
            distance={<FormattedMessage id="km" defaultMessage="km" />}
            closePreviewer={this.props.closePreviewer}
            removeTourFromMap={this.props.removeTourFromMap}
            readMore={this.state.readMore}
            readMoreChange={this.readMoreChange}
            action={this.action}
            urlTitle={this.urlTitle(this.props.resp.data)}
            openModalTourDownload={this.props.openModalTourDownload}
            downloadTourGps={this.props.downloadTourGps}
            TourDownloadBasketData={this.props.TourDownloadBasketData}
            TourDownloadCoord={this.props.TourDownloadCoord}
            lang={this.state.lang}
            router={this.props.router}
            fromList={this.props.fromList}
            userAuth={this.props.userAuth}
          />
        );
      case 'place':
        return (
          <PlacePreview
            previewJson={this.props.resp.data}
            fetching={this.props.resp.fetching}
            fetched={this.props.resp.fetched}
            distance={<FormattedMessage id="km" defaultMessage="km" />}
            closePreviewer={this.props.closePreviewer}
            removeTourFromMap={this.props.removeTourFromMap}
            readMore={this.state.readMore}
            readMoreChange={this.readMoreChange}
            action={this.action}
            urlTitle={this.urlTitle(this.props.resp.data)}
            openModalTourDownload={this.props.openModalTourDownload}
            downloadTourGps={this.props.downloadTourGps}
            TourDownloadBasketData={this.props.TourDownloadBasketData}
            TourDownloadCoord={this.props.TourDownloadCoord}
            lang={this.state.lang}
            router={this.props.router}
            hasUserPermition={this.hasUserPermition}
            fromList={this.props.fromList}
            createTour={this.props.createTour}
          />
        );
      default:
        return (
          <TourPreview
            previewJson={this.props.resp.data}
            fetching={this.props.resp.fetching}
            fetched={this.props.resp.fetched}
            distance={<FormattedMessage id="km" defaultMessage="km" />}
            closePreviewer={this.props.closePreviewer}
            removeTourFromMap={this.props.removeTourFromMap}
            readMore={this.state.readMore}
            readMoreChange={this.readMoreChange}
            action={this.action}
            urlTitle={this.urlTitle(this.props.resp.data)}
            openModalTourDownload={this.props.openModalTourDownload}
            downloadTourGps={this.props.downloadTourGps}
            TourDownloadBasketData={this.props.TourDownloadBasketData}
            TourDownloadCoord={this.props.TourDownloadCoord}
            lang={this.state.lang}
            router={this.props.router}
            fromList={this.props.fromList}
            userAuth={this.props.userAuth}
            hasUserPermition={this.hasUserPermition}
            fullData={this.props.resp}
            changeTourMode={this.props.changeTourMode}
          />
        );
    }
  };

  render() {
    const { width } = this.state;
    const isTablet = width <= 767;
    if (
      Object.keys(this.props.resp.data).length === 0 ||
      ifId(this.props.router)
    ) {
      return null;
    }
    if (isTablet || isMobileOnly) {
      return (
        <MobilePreview
          previewJson={this.props.resp.data}
          fetching={this.props.resp.fetching}
          fetched={this.props.resp.fetched}
          distance={<FormattedMessage id="km" defaultMessage="km" />}
          closePreviewer={this.props.closePreviewer}
          removeTourFromMap={this.props.removeTourFromMap}
          action={this.action}
          urlTitle={this.urlTitle(this.props.resp.data)}
          router={this.props.router}
        />
      );
    }
    return this.getPreviewByScope();
  }
}

Previewer.displayName = 'Previewer';
Previewer.propTypes = {
  TourDownloadBasketData: PropTypes.func,
  TourDownloadCoord: PropTypes.func,
  closePreviewer: PropTypes.func,
  downloadTourGps: PropTypes.shape(DownloadTourGpsProps),
  mapData: PropTypes.shape(MapDataProps),
  openModalTourDownload: PropTypes.func,
  poly: PropTypes.shape(PreviewPolyProps),
  removeTourFromMap: PropTypes.func,
  resp: PropTypes.shape({
    data: PropTypes.object,
    error: PropTypes.any,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
  }),
  router: PropTypes.shape(RouterProps),
  tourFullDataId: PropTypes.func,
  tourFullMapPosition: PropTypes.func,
};

const MapStateToProps = (store) => {
  return {
    resp: store.fetchPreviewData,
    poly: store.fetchPreviewPoly,
    mapData: store.mapDataReducer,
    downloadTourGps: store.tourDownload,
    scope: store.mapScopeReducer.scope,
    router: store.router,
    userAuth: store.authentication.user,
    fullData: store.tourFullData,
  };
};
const MatchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closePreviewer: setPreviewTourData,
      removeTourFromMap: setPreviewTourPoly,
      tourFullDataId,
      tourFullMapPosition,
      openModalTourDownload,
      TourDownloadBasketData,
      TourDownloadCoord,
      cleanPreviewTourData,
      changeTourMode,
    },
    dispatch
  );
};

export default connect(MapStateToProps, MatchDispatchToProps)(Previewer);
